import React, {
  MutableRefObject,
  PropsWithChildren,
  createContext,
  useMemo,
  useRef,
  useState,
} from 'react';

import mapboxgl from 'mapbox-gl';

import { useAppSelector } from 'state/hooks';
import { selectMapStyle } from 'state/workflowSlice';

import { MapStyle } from 'appConstants';

interface MapContextType {
  refMap: MutableRefObject<mapboxgl.Map | null>;
  mapReady: boolean;
  setMapReady: (ready: boolean) => void;
  refStyleReady: MutableRefObject<boolean>;
  mapStyle: MapStyle;
}

export const MapContext = createContext<MapContextType | null>(null);

export function MapContextProvider({ children }: PropsWithChildren<{}>) {
  const refMap = useRef<mapboxgl.Map>(null);
  const [mapReady, setMapReady] = useState(false);
  const refStyleReady = useRef(false);
  const mapStyle = useAppSelector(selectMapStyle);

  const contextValue = useMemo(
    () => ({ refMap, mapReady, setMapReady, refStyleReady, mapStyle }),
    [refMap, mapReady, refStyleReady, mapStyle],
  );

  return (
    <MapContext.Provider value={contextValue}>{children}</MapContext.Provider>
  );
}
